import * as React from 'react';
import { Alert } from '@grandvisionhq/common';

const DiscountDescriptions = ({ descriptions , labels  })=>/*#__PURE__*/ React.createElement("div", {
        className: "cart-totals__discount-descriptions"
    }, /*#__PURE__*/ React.createElement(Alert, {
        type: "info",
        title: labels.promotionTitle,
        message: descriptions,
        className: "cart-totals__alert"
    }))
;

export { DiscountDescriptions };
//# sourceMappingURL=DiscountDescriptions.js.map
